// src/identity/team-type/types.ts
var IdentityTeamTypeAriResourceOwner = "identity", IdentityTeamTypeAriResourceType = "team-type";

export {
  IdentityTeamTypeAriResourceOwner,
  IdentityTeamTypeAriResourceType
};
